/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgSpectrum = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.222 14.947h-.445l-.18-.09c-.197-.1-4.88-2.5-4.88-7.38V3.942l.43-.5L3.5 3.4a6.98 6.98 0 0 0 3.832-1.9l.295-.33h.75l.293.33a6.955 6.955 0 0 0 3.842 1.9l.34.047.43.5v3.53c0 4.886-4.682 7.273-4.88 7.38l-.18.09Zm-4.5-10.572v3.102c0 4.085 3.795 6.208 4.283 6.463.5-.25 4.282-2.377 4.282-6.463V4.375A8 8 0 0 1 8 2.25a8 8 0 0 1-4.283 2.125h.005Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.5 4.755h-1V6.96h1V4.755Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.94 5.352 8.38 6.91l.708.707 1.559-1.56-.707-.706Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.245 7.5H9.04v1h2.205v-1Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.09 8.38-.707.706 1.56 1.56.706-.707-1.559-1.56Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.5 9.04h-1v2.205h1V9.04Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m6.912 8.382-1.559 1.56.707.706L7.62 9.09l-.708-.707Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.96 7.5H4.755v1H6.96v-1Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m6.058 5.352-.708.707 1.56 1.56.707-.708-1.56-1.56Z"
}));

export default SvgSpectrum;